import React from "react";
import MaterialTableRtl from "../../UI/MaterialTableRtl/MaterialTableRtl";
import { client } from "../../../service/ApolloClient/ApolloClient";
import { QUERY_CHEQUE_CONTRACTS } from "../../../service/ApolloClient/ApolloQueries";
import NumberFormat from "react-number-format";
import { MUTATION_REMOVE_CHEQUE_CONTRACT } from "../../../service/ApolloClient/ApolloMutation";
import { SuccessToast } from "../../../hoc/ToastNotify/ToastNotify";
import { confirmAlert } from "react-confirm-alert";

class ChequeContractList extends React.Component {
  tableRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      data: [],
      columns: [
        {
          title: "#",
          field: "id",
          render: (rowData) => {
            return (
              <a href={`/cheque-contract/edit/${rowData.id}`}>{rowData.id}</a>
            );
          },
        },
        {
          title: "طرف اول",
          field: "first_party_fullname",
          render: (rowData) =>
            rowData.first_party_id ? (
              <a href={`/person/edit/${rowData.first_party_id}`}>
                {rowData.first_party_fullname}
              </a>
            ) : (
              "مشخص نشده"
            ),
        },
        {
          title: "طرف دوم",
          field: "second_party_fullname",
          render: (rowData) =>
            rowData.second_party_id ? (
              <a href={`/person/edit/${rowData.second_party_id}`}>
                {rowData.second_party_fullname}
              </a>
            ) : (
              "مشخص نشده"
            ),
        },
        {
          title: "چک مرتبط",
          field: "cheque_num",
          sorting: "false",
          render: (rowData) => (
            <a href={`/cheque/cheque-contract/${rowData.id}`}>
              {rowData.cheque_num}
            </a>
          ),
        },
        {
          title: "ارزش واقعی",
          field: "value_real",
          render: (rowData) => (
            <NumberFormat
              value={rowData.value_real}
              displayType={"text"}
              thousandSeparator={true}
            />
          ),
        },
        {
          title: "ارزش توافقی",
          field: "value_agreement",
          render: (rowData) => (
            <NumberFormat
              value={rowData.value_agreement}
              displayType={"text"}
              thousandSeparator={true}
            />
          ),
        },
        {
          title: "نرخ کاهش",
          field: "ratio",
          // render: (rowData) => rowData.ratio / 100,
        },

        {
          title: "تاریخ قرارداد",
          field: "agreement_date_fa",
          render: (rowData) => rowData.agreement_date_fa,
        },
      ],
    };

    this.remoteData = this.remoteData.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  componentDidMount() {
    // this.fetchData();
  }

  remoteData = (query) => {
    return client
      .query({
        query: QUERY_CHEQUE_CONTRACTS,
        variables: {
          page: query.page + 1,
          limit: query.pageSize,
          search: query.search,
          orderBy: query.orderBy ? query.orderBy.field : null,
          orderDirection: query.orderDirection,
          user: parseInt(this.props.user),
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        let data = structuredClone(res.data);
        return {
          data: data.chequeContracts.data,
          page: query.page,
          totalCount: data.chequeContracts.total,
        };
      });
  };

  handleRemove = (id) => {
    confirmAlert({
      title: "تاییدیه حذف",
      message: "آیا واقعا می خواهید حذف کنید.",
      buttons: [
        {
          label: "بله",
          onClick: () => {
            client
              .mutate({
                mutation: MUTATION_REMOVE_CHEQUE_CONTRACT,
                variables: {
                  id: id,
                },
              })
              .then((res) => {
                let d = res.data.removeCarContract;
                this.tableRef.current.onQueryChange();
                SuccessToast("با موفقیت حذف گردید");
              })
              .catch((err) => console.log(err));
          },
        },
        {
          label: "بی خیال",
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    const { columns, data } = this.state;
    let title = "خرید دین" + " " + (this.props.name ? this.props.name : null)
    return (
      <MaterialTableRtl
        tableRef={this.tableRef}
        columns={columns}
        data={this.remoteData}
        handleRemove={this.handleRemove}
        editLink={"/cheque-contract/edit/"}
        needExport={true}
        title={title}
        pdfName={this.props.pdfName ? this.props.pdfName : title}
      />
    );
  }
}

export default ChequeContractList;
